import React from 'react'

export function YearAlertSkeleton() {
    return (
        <div className="bg-white border border-[#FC4C5933] rounded-[8px] p-3 min-h-[132px] flex flex-col gap-3">
            <div className="flex items-center gap-2">
                <div className="w-7 h-7 shrink-0 rounded-full bg-[#FC4C5933]" />
                <div className="h-5 w-1/3 rounded bg-lightBG" />
                <div className="h-5 w-1/4 rounded bg-[#FC4C5933]" />
            </div>
            <div className="h-4 w-1/2 rounded bg-lightBG" />
            <div className="h-9 w-full rounded bg-[#FFF5F6]" />
        </div>
    )
}

export default function YearAlertsSkeleton() {
    return (
        <div aria-hidden="true" className="blur animate-pulse pointer-events-none select-none flex flex-col gap-3">
            <div className="flex items-center gap-1 pl-2 pb-3 border-b border-b-[#E8E0FF]">
                <div className="w-7 h-7 shrink-0 rounded-full bg-[#FC4C5933]" />
                <div className="h-5 w-32 rounded bg-lightBG" />
            </div>
            {[0, 1, 2].map((index) => (
                <div key={index} className="bg-[#F8F8FB] rounded-[4px] p-2">
                    <div className="flex items-center gap-1">
                        <div className="w-7 h-7 shrink-0 rounded-full bg-[#FC4C5933]" />
                        <div className="h-5 w-28 rounded bg-lightBG" />
                    </div>
                    <div className="mt-[11px]"><YearAlertSkeleton /></div>
                </div>
            ))}
        </div>
    )
}
